export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-accent-100 text-accent-700 rounded-full text-xs font-label mb-3">
            <i className="ri-mail-send-line"></i>联系我们
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            有料要爆？我们等你
          </h2>
          <p className="text-sm text-foreground-500 max-w-[500px] mx-auto">
            欢迎投稿、合作与反馈，你的每一条线索都可能成为下一个头条
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          <div className="group bg-background-100 border border-background-200/70 rounded-2xl p-6 text-center hover:border-primary-300 transition-all duration-300 cursor-pointer">
            <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-4">
              <i className="ri-mail-line text-xl"></i>
            </div>
            <h3 className="font-label text-base font-semibold text-foreground-900 mb-2">
              爆料投稿
            </h3>
            <p className="text-xs text-foreground-500 leading-relaxed mb-3">
              将你掌握的娱乐圈内幕发送给我们
            </p>
            <span className="text-sm text-primary-600 font-label">
              tips@heilia.com
            </span>
          </div>

          <div className="group bg-background-100 border border-background-200/70 rounded-2xl p-6 text-center hover:border-primary-300 transition-all duration-300 cursor-pointer">
            <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-600 mb-4">
              <i className="ri-briefcase-line text-xl"></i>
            </div>
            <h3 className="font-label text-base font-semibold text-foreground-900 mb-2">
              商务合作
            </h3>
            <p className="text-xs text-foreground-500 leading-relaxed mb-3">
              广告投放、品牌合作与资源互换
            </p>
            <span className="text-sm text-primary-600 font-label">
              biz@heilia.com
            </span>
          </div>

          <div className="group bg-background-100 border border-background-200/70 rounded-2xl p-6 text-center hover:border-primary-300 transition-all duration-300 cursor-pointer">
            <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-4">
              <i className="ri-feedback-line text-xl"></i>
            </div>
            <h3 className="font-label text-base font-semibold text-foreground-900 mb-2">
              问题反馈
            </h3>
            <p className="text-xs text-foreground-500 leading-relaxed mb-3">
              遇到问题或有建议？随时告诉我们
            </p>
            <span className="text-sm text-primary-600 font-label">
              support@heilia.com
            </span>
          </div>
        </div>

        <div className="mt-6 text-center">
          <p className="text-xs text-foreground-400">
            我们会在24小时内回复您的来信。爆料投稿将严格保护信源隐私。
          </p>
        </div>
      </div>
    </section>
  );
}